export default __webpack_public_path__ + "images/Southern.efb490.jpg";